import React from "react";
import {connect} from "react-redux";
import {Admission} from "@reside/reside-api-admission";
import {Text, DropdownMenuItem} from "@reside/ui";
import {Dictionary} from "lodash";

import {select, AppState} from "../../../../store";
import {getResidentTestId, isDeleteRestrictedForUser} from "../../helper";
import {ModalName, useDashboardModalContext} from "../../DashboardModalContext";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";

export const Renderer = ({
  admission,
  isOrgAdmin,
  isFacilityAdmin,
  facilityFlagsById,
}: {
  admission: AdmissionFromSearch;
  isOrgAdmin: boolean;
  isFacilityAdmin: boolean;
  facilityFlagsById: Dictionary<{[key: string]: boolean}>;
}) => {
  const {toggleModal} = useDashboardModalContext(ModalName.CANCEL);
  const isDisabled = isDeleteRestrictedForUser({
    facilityFlags: facilityFlagsById[admission.facilityId],
    isOrgAdmin,
    isFacilityAdmin,
  });

  return (
    <DropdownMenuItem
      onClick={() => {
        !isDisabled && toggleModal(admission);
      }}
      testId={getResidentTestId(admission, Admission.StatusEnum.CANCELLED)}
      disabled={isDisabled}
    >
      <Text color="deepOrange100">Delete</Text>
    </DropdownMenuItem>
  );
};

const mapStateToProps = (state: AppState) => ({
  isOrgAdmin: select.adminSession.isOrgAdmin(state),
  isFacilityAdmin: select.adminSession.isFacilityAdmin(state),
  facilityFlagsById: select.adminSession.facilityFlagsById(state),
});

export const DeleteAdmissionDropdownItem = connect(mapStateToProps)(Renderer);
